import thLocale from 'element-ui/lib/locale/lang/th'
import home from './th/home'

const th = {
    language: 'ภาษาไทย',
    message: {
        'home': {
            ...home,
            enterEmail: 'กรุณากรอกอีเมล',
            save: 'บันทึก',
            saveSuccess: 'บันทึกสำเร็จ',
            pointHistory: 'ประวัติคะแนน',
            type: 'ประเภท',
            remark: 'หมายเหตุ',
            pendingComment: 'รอรีวิว',
            commented: 'รีวิวแล้ว',
            selectDate: 'เลือกวันที่',
            loginSuccess: 'เข้าสู่ระบบสำเร็จ',
            loginFail: 'เข้าสู่ระบบล้มเหลว',
            close: 'ปิด',
            required: 'จำเป็น',
            nickname: 'ชื่อเล่น',
            enterNickname: 'กรุณากรอกชื่อเล่น',
            gender: 'เพศ',
            male: 'ชาย',
            female: 'หญิง',
            secret: 'ไม่ระบุ',
            birthday: 'วันเกิด',
            checkoutLoadFailed: 'โหลดข้อมูลการชำระเงินไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
            checkoutErrorTitle: 'แจ้งเตือน',
            goAddAddress: 'เพิ่มที่อยู่จัดส่ง',
            shop_order_selectOrAddAddress: 'กรุณาเพิ่มที่อยู่จัดส่งและตั้งเป็นค่าเริ่มต้นก่อนชำระเงิน',
            shop_order_cartEmpty: 'ตะกร้าว่างเปล่า ไม่สามารถชำระเงินได้',
            shop_order_cartHasNotActive: 'มีสินค้าที่ยังไม่วางขายหรือไม่ถูกต้อง ไม่สามารถชำระเงินได้',
            shop_order_cartHasNotMarketable: 'มีสินค้าที่เลิกขายแล้ว ไม่สามารถชำระเงินได้',
            shop_order_cartHasLowStock: 'สินค้าในสต็อกไม่เพียงพอ ไม่สามารถชำระเงินได้',
            shop_order_cartHasExpiredGoods: 'สินค้าบางรายการของร้านหมดอายุแล้ว ไม่สามารถชำระเงินได้',
            shop_order_typeIsNull: 'ไม่สามารถระบุประเภทคำสั่งซื้อ กรุณาตรวจสอบประเภทสินค้า',
            shop_order_goodsNotFound: 'ไม่พบข้อมูลสินค้าหรือถูกลบแล้ว',
            shop_order_giftNotForSale: 'สินค้าของแถมไม่สามารถซื้อโดยตรงได้',
            common_message_badRequest: 'คำขอไม่ถูกต้อง กรุณาตรวจสอบสินค้าและพารามิเตอร์',
        },
    },
    '手机号码最小长度为8位': 'ความยาวขั้นต่ำของหมายเลขโทรศัพท์มือถือคือ 8 หลัก',
    '邮箱账号名称最小长度为6位': 'ความยาวขั้นต่ำของชื่อบัญชีอีเมลคือ 6 ตัวอักษร',
    '邮箱只能包含英文，数字等字符': 'กล่องจดหมายสามารถมีได้เฉพาะอักขระ เช่น ภาษาอังกฤษและตัวเลข',
    '请选择正确的收货地址': 'กรุณาเลือกที่อยู่ในการจัดส่งให้ถูกต้อง',
    Dict_language_status_0: 'ปิดใช้งาน',
    Dict_language_status_1: 'เปิดใช้งาน',
    Dict_member_label_type_1: 'ป้ายตามเงื่อนไข',
    Dict_member_label_type_2: 'ป้ายกำหนดเอง',
    Dict_member_level_type_0: 'ระดับการบริโภค (LV)',
    Dict_member_level_type_1: 'สมาชิกแบบชำระเงิน (VIP)',
    Dict_member_growth_action_type_1: 'สั่งซื้อสินค้า',
    Dict_member_growth_action_type_2: 'เข้าสู่ระบบรายวัน',
    Dict_member_growth_action_type_3: 'โพสต์รีวิว',
    Dict_member_growth_action_type_4: 'กรอกข้อมูลให้ครบถ้วน',
    Dict_paid_member_payment_type_0: 'ชำระด้วยยอดคงเหลือ',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'ใช้งานได้',
    Dict_paid_member_record_status_1: 'หมดอายุ',
    Dict_paid_member_record_status_2: 'คืนเงินแล้ว',
    Dict_point_lottery_prize_type_0: 'คะแนน',
    Dict_point_lottery_prize_type_1: 'คูปอง',
    Dict_point_lottery_prize_type_2: 'ของรางวัล',
    Dict_point_lottery_prize_type_3: 'ขอบคุณที่ร่วมสนุก',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'อีเมล',
    Dict_notification_channel_type_2: 'ข้อความภายใน',
    Dict_notification_channel_type_3: 'การแจ้งเตือนแบบพุช',
    Dict_announcement_status_0: 'ฉบับร่าง',
    Dict_announcement_status_1: 'เผยแพร่แล้ว',
    Dict_announcement_status_2: 'นำออกแล้ว',
    Dict_live_permission_status_0: 'ยังไม่ได้สมัคร',
    Dict_live_permission_status_1: 'กำลังตรวจสอบ',
    Dict_live_permission_status_2: 'เปิดใช้งานแล้ว',
    Dict_live_permission_status_3: 'ถูกปฏิเสธ',
    Dict_live_room_status_0: 'ยังไม่เริ่ม',
    Dict_live_room_status_1: 'กำลังถ่ายทอดสด',
    Dict_live_room_status_2: 'สิ้นสุดแล้ว',
    Dict_live_room_status_3: 'ขัดข้องผิดปกติ',
    Dict_live_room_type_0: 'ถ่ายทอดสดแพลตฟอร์ม',
    Dict_live_room_type_1: 'ถ่ายทอดสดร้านค้า',
    Dict_store_type_0: 'ร้านค้าส่วนบุคคล',
    Dict_store_type_1: 'ร้านค้าองค์กร',
    Dict_store_sign_status_0: 'รอเซ็นสัญญา',
    Dict_store_sign_status_1: 'เซ็นสัญญาแล้ว',
    Dict_store_sign_status_2: 'ยกเลิกสัญญา',
    Dict_store_business_change_status_0: 'รอตรวจสอบ',
    Dict_store_business_change_status_1: 'อนุมัติแล้ว',
    Dict_store_business_change_status_2: 'ถูกปฏิเสธ',
    Dict_decoration_page_type_0: 'หน้าแรก',
    Dict_decoration_page_type_1: 'หน้าหมวดหมู่',
    Dict_decoration_page_type_2: 'หน้ากิจกรรม',
    Dict_decoration_page_type_3: 'หน้ากำหนดเอง',
    Dict_decoration_status_0: 'ฉบับร่าง',
    Dict_decoration_status_1: 'เผยแพร่แล้ว',
    Dict_decoration_popup_trigger_page_0: 'หน้าแรกแพลตฟอร์ม',
    Dict_decoration_popup_trigger_page_1: 'ศูนย์สมาชิก',
    Dict_decoration_popup_trigger_page_2: 'ชำระเงินสำเร็จ',
    Dict_decoration_popup_target_user_0: 'ผู้ใช้ทั้งหมด',
    Dict_decoration_popup_target_user_1: 'สมาชิกฟรี',
    Dict_decoration_popup_target_user_2: 'สมาชิกแบบชำระเงิน',
    Dict_decoration_popup_frequency_0: 'ครั้งเดียวถาวร',
    Dict_decoration_popup_frequency_1: 'ทุกครั้งที่เข้า',
    Dict_decoration_popup_frequency_2: 'ความถี่กำหนดเอง',
    Dict_track_event_type_page_view: 'เข้าชมหน้า',
    Dict_track_event_type_click: 'คลิก',
    Dict_track_event_type_add_to_cart: 'เพิ่มลงตะกร้า',
    Dict_track_event_type_search: 'ค้นหา',
    Dict_track_event_type_purchase: 'ซื้อ',
    Dict_track_event_type_live_watch: 'ดูถ่ายทอดสด',
    Dict_reconcile_period_type_0: 'รายวัน',
    Dict_reconcile_period_type_1: 'รายสัปดาห์',
    Dict_reconcile_period_type_2: 'รายเดือน',
    Dict_store_settlement_status_0: 'รอชำระบัญชี',
    Dict_store_settlement_status_1: 'ชำระบัญชีแล้ว',
    Dict_distributor_status_0: 'รอตรวจสอบ',
    Dict_distributor_status_1: 'ตรวจสอบแล้ว',
    Dict_distributor_status_2: 'ถูกปฏิเสธ',
    Dict_distribution_commission_type_0: 'ค่าคอมมิชชันทางตรง',
    Dict_distribution_commission_type_1: 'ค่าคอมมิชชันทางอ้อม',
    Dict_configuration_status_0: 'ปิดใช้งาน',
    Dict_configuration_status_1: 'เปิดใช้งาน',
    ...thLocale
}
export default th
